module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"learnMore":"Learn more"},"cz":{"learnMore":"Zjistit více"},"hu":{"learnMore":"Többet tud"},"pl":{"learnMore":"Ucz się więcej"},"uk":{"learnMore":"Вчи більше"},"sk":{"learnMore":"Uč sa viac"}}')
  delete Component.options._Ctor
}
